import {
  differenceInCalendarISOWeeks,
  endOfISOWeek,
  getISOWeek,
  getISOWeekYear,
  isWeekend,
  startOfISOWeek,
} from 'date-fns'

// The header is drawn inside the virtualized row that opens a week, so the virtualizer has to be
// told what it costs — see RowGroupingProps.headerSize.
export const WEEK_GROUP_HEADER_SIZE = 38

const parseEventDate = (value?: string | null) => {
  if (!value) {
    return undefined
  }

  const date = new Date(value)

  return Number.isNaN(date.getTime()) ? undefined : date
}

/**
 * The ISO year travels with the week on purpose: W52 of one year and W52 of the next would
 * otherwise collapse into a single run when a page boundary happens to fall between them.
 *
 * Every date here is read in the browser's zone, the same one `format` renders the cells in. Doing
 * it in UTC instead would put a 01:00 Saturday kick-off in Warsaw on the Friday.
 */
export const getWeekKey = (value?: string | null) => {
  const date = parseEventDate(value)

  return date ? `${getISOWeekYear(date)}-W${String(getISOWeek(date)).padStart(2, '0')}` : undefined
}

export const isWeekendEvent = (value?: string | null) => {
  const date = parseEventDate(value)

  return !!date && isWeekend(date)
}

export type WeekDescription = {
  start: Date
  end: Date
  /** 0 is the week we are in, 1 the one after it, -1 the one before. */
  offsetFromNow: number
}

export const describeWeek = (value: string | null | undefined, now: Date): WeekDescription | undefined => {
  const date = parseEventDate(value)

  if (!date) {
    return undefined
  }

  return {
    start: startOfISOWeek(date),
    end: endOfISOWeek(date),
    offsetFromNow: differenceInCalendarISOWeeks(date, now),
  }
}
